import {Component, OnInit} from '@angular/core';
import {PsusService} from "../shared/model/psus.service";
import {AuthService} from "../shared/security/auth.service";
import {FieldsService} from "../shared/model/fields.service";
import {Observable} from "rxjs";
import {Field} from "../shared/model/field";
import {CommandService} from "../shared/model/command.service";
import {sleepMilliseconds} from "../shared/util/sleep-util";
import {DEFAULT_POWER, OVERBOOST} from "../shared/model/psu";
import {isUndefined} from "util";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-lighting',
  templateUrl: './lighting.component.html',
  styleUrls: ['./lighting.component.css']
})
export class LightingComponent implements OnInit {

  fields$: Observable<Field[]>;

  showLightingDetail: boolean = false;
  lightingDetailTitle: string = "";
  lightingDetailText: string = "";

  dbPath: string = "";

  clubId: string;
  fieldId: string;
  cpuId: string;
  psu: string;
  usesField: string;
  simulate: boolean;
  type: string;

  description: string;  // needed for switchboard (RS485 switches)

  collapseDetail: boolean;

  constructor(private fieldsService: FieldsService, private psusService: PsusService, private authService: AuthService, private commandService: CommandService, private translate: TranslateService ) {
  }

  ngOnInit() {
    this.clubId = this.authService.getClubIdForUser();
    this.fields$ = this.fieldsService.findFieldsForClubId(this.clubId);

    this.fields$.subscribe(
      fields => console.log,
      error => console.log
    );
    this.collapseDetail = true;
  }

  isSuperUser(): boolean {
    return this.authService.isSuperUser();
  }

  isSuperAdmin(): boolean {
    return this.authService.isSuperAdminUser();
  }

  isPlayer(fieldType: string): boolean {
    return this.authService.isPlayer() || fieldType === 'switchboard';
  }

  isSwitchBoard(fieldType: string) {
    return fieldType === 'switchboard';
  }

  isOnlyPlayer() {
    return this.authService.isPlayer();
  }

  invalidatePSUs(clubId: string, field: Field ) {
    var tmpKey = 0;

    for (let cpu of field.cpus) {
      for(let psu of cpu.psus) {
        tmpKey = Number(psu.$key);
        let path = clubId + "/" + field.$key + "/cpus/" + cpu.$key + "/psus/" + psu.$key;
        this.psusService.updatePsuPowerConsumption(path, 0);
        this.psusService.updatePsuIst(path, -2);
      }
    }
  }

  setField(clubId: string, field: Field, soll: number) {
    this.commandService.addCommand(clubId, field.$key, null, null, "SET", soll, false, "", this.authService.getUserName(), "field");
  }

  toggleOverboost(clubId: string, field: Field) {
    let isOverboosted: boolean = field.isOverboosted;

    // console.log(`toggleOverboost(): defaultPower: ${defaultPower}, overBoostPower: ${overBoostPower}`);

    if ( !isOverboosted ) {
      this.commandService.addCommand(clubId, field.$key, "", null, "ST_BOOST_ON", 0, false, "", this.authService.getUserName());
    } else if ( isOverboosted ) {
      this.commandService.addCommand(clubId, field.$key, "", null, "ST_BOOST_OFF", 0, false, "", this.authService.getUserName());
    } else {
      console.error('Cannot switch on overboost.');
    }

  }

  getField(clubId: string, field: Field) {
    this.commandService.addCommand(clubId, field.$key, "", null, "GET", -1, false, "", this.authService.getUserName());
  }

  getPowerStatus(clubId: string, field: Field) {
    this.commandService.addCommand(clubId, field.$key, "", null, "GET_POWER_STATUS", -1, false, "", this.authService.getUserName());
  }

  switchPSU(location: string, fixture: string, clubId: string, fieldId: string, cpuId: string, psu: string, usesField: string, simulate: boolean, description: string) {
   // 'Individuele aanpassing intensiteit ' + cpu.location + ', armatuur ' + psu.$key

    this.translate.get('l.switch')
      .subscribe((res: string) => {
        this.lightingDetailTitle = res;

        this.translate.get('l.intensity')
          .subscribe((res2: string) => {
            this.lightingDetailText = res2 + location + ', ' + fixture;
            this.clubId = clubId;
            this.fieldId = fieldId;
            this.cpuId = cpuId;
            this.psu = psu;
            this.simulate = simulate;
            this.usesField = usesField;
            this.type = 'psu';
            this.description = description;  // psu description e.g. RS485

            this.showModalLightingDetailWindow(true);
          });
      });
  }

  switchCPU(location: string, clubId: string, fieldId: string, cpuId: string, usesField: string, fieldType: string) {
    // 'Individuele aanpassing intensiteit ' + cpu.location + ', armatuur ' + psu.$key

    this.translate.get('l.switchgroup')
      .subscribe((res: string) => {
        this.lightingDetailTitle = res;

        this.translate.get('l.intensitygroup')
          .subscribe((res2: string) => {
            this.lightingDetailText = res2 + location;
            this.clubId = clubId;
            this.fieldId = fieldId;
            this.cpuId = cpuId;
            this.psu = null;
            this.simulate = false;
            this.usesField = usesField;
            this.type = 'cpu';
            if ( fieldType === 'switchboard' ) {
              this.description = 'RS485 switchboard';
            } else {
              this.description = 'Other type of field';
            }

            this.showModalLightingDetailWindow(true);
          });
      });
  }


  showModalLightingDetailWindow(show: boolean) {
    this.showLightingDetail = show;
  }

  processConfirmation(result: number) {
    this.showModalLightingDetailWindow(false);
    let path = this.clubId + "/" + this.fieldId + "/cpus/" + this.cpuId + "/psus/" + this.psu;
    var s: string = "";

    if ( result >= 0 ) {  // -1 = Annuleren, andere waarden zijn schakelintensiteitsinstellingen
      // invalidate current lamp status. The lamp might be switched off and the return value of the command will set it correctly
      //this.psusService.updatePsuIst(path, -1);
      //this.psusService.updatePsuPowerConsumption(path, 0);

      //var s = this.commandService.addCommandNew(this.clubId, this.fieldId, this.cpuId, Number(this.psu), "GET_POWER_STATUS", -1, this.simulate, this.usesField, this.authService.getUserName(), "");

      if ( this.psu === null ) {
        this.commandService.addCommand(this.clubId, this.fieldId, this.cpuId, null, "SET", result, this.simulate, this.usesField, this.authService.getUserName());
      } else {
        this.commandService.addCommand(this.clubId, this.fieldId, this.cpuId, Number(this.psu), "SET", result, this.simulate, this.usesField, this.authService.getUserName());
      }
    }
    if ( result === -2 )  { // GET
      if ( this.psu === null ) {
        this.commandService.addCommand(this.clubId, this.fieldId, this.cpuId, null, "GET", result, this.simulate, this.usesField, this.authService.getUserName());
      } else {
        this.commandService.addCommand(this.clubId, this.fieldId, this.cpuId, Number(this.psu), "GET", result, this.simulate, this.usesField, this.authService.getUserName());
      }
    }
    if ( result === -3 )  { // GET_POWER_STATUS
      if ( this.psu === null ) {
        this.commandService.addCommand(this.clubId, this.fieldId, this.cpuId, null, "GET_POWER_STATUS", result, this.simulate, this.usesField, this.authService.getUserName());
      } else {
        this.commandService.addCommand(this.clubId, this.fieldId, this.cpuId, Number(this.psu), "GET_POWER_STATUS", result, this.simulate, this.usesField, this.authService.getUserName());
      }
    }

  }

  toggleCollapse() {
    this.collapseDetail = !this.collapseDetail;
  }


  getFieldOld(clubId: string, field: Field) {
    var tmpKey = 0;
    var shallDelay: boolean = false;

    this.invalidatePSUs(clubId, field);

    for(let i=0; i<15; i++) {
      shallDelay = false;
      for (let cpu of field.cpus) {
        for(let psu of cpu.psus) {
          tmpKey = Number(psu.$key);
          if(tmpKey === i) {
            shallDelay = true;
            this.commandService.addCommand(clubId, field.$key, cpu.$key, tmpKey, "GET", -1, cpu.simulate, cpu.usesField, this.authService.getUserName());
          }
        }
      }
      if( shallDelay ) {
        sleepMilliseconds(3500);
      }
    }

    this.fieldsService.updateFieldSoll(clubId, field.$key, -1);
  }


  setFieldOld(clubId: string, field: Field, soll: number) {
    var tmpKey = 0;
    var shallDelay: boolean = false;

    this.invalidatePSUs(clubId, field);

    for(let i=0; i<15; i++) {
      shallDelay = false;
      for (let cpu of field.cpus) {
        for(let psu of cpu.psus) {
          tmpKey = Number(psu.$key);
          if(tmpKey === i) {
            shallDelay = true;
            this.commandService.addCommand(clubId, field.$key, cpu.$key, tmpKey, "SET", soll, cpu.simulate, cpu.usesField, this.authService.getUserName());
          }
        }
      }
      if( shallDelay ) {
        sleepMilliseconds(3500);
      }
    }
    this.fieldsService.updateFieldSoll(clubId, field.$key, soll);

  }

}
